import { AdaptiveDialog } from '@/components/blocks/AdaptiveDialog';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { DpOutlinedOTPInput } from '@/components/blocks/OTPInput';
import { useTimedBlocker } from '@/data/Content/Timer';
import { Stack, Typography } from '@mui/material';

interface Props {
	otp: string;
	isLoading: boolean;
	onResendCode: () => void;
	onChange: (otp: string[]) => void;
	onSubmit: () => void;
	onClose: () => void;
}

export const ModalAccountLoginPhoneOtp: React.FC<Props> = ({
	otp,
	isLoading,
	onResendCode,
	onChange,
	onClose,
	onSubmit,
}) => {
	const { isBlocked, remainingTime } = useTimedBlocker({
		active: true,
		duration: 60,
	});

	return (
		<AdaptiveDialog onClose={onClose}>
			<Stack
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					gap: '16px',
				}}
			>
				<Typography
					component={'h1'}
					sx={{
						fontSize: { md: 'var(--font-size-xl)', xs: 'var(--font-size-lg)' },
						fontWeight: '800',
						letterSpacing: '0px',
						color: '#2C2C2C',
						textTransform: 'uppercase',
						opacity: 1,
					}}
				>
					{'Ya casi terminas'}
				</Typography>
				<Typography
					sx={{
						fontSize: 'var(--font-size-sm)',
						color: '#2C2C2C',
					}}
				>
					{'Ingresa el código que acabamos de enviar al celular que registraste'}
				</Typography>
				<DpOutlinedOTPInput value={otp} otpLength={6} onChange={onChange} />
				<DpButton
					variant="primary"
					fullWidth
					disabled={isLoading}
					sx={{ maxWidth: { xs: '100%', md: '300px' } }}
					onClick={onSubmit}
				>
					{'Enviar'}
				</DpButton>
				<Stack spacing={1}>
					<Typography
						sx={{
							fontSize: 'var(--font-size-sm)',
							color: '#424242',
						}}
					>
						{'¿Aún no llega tu código? No te preocupes, podrás generar uno nuevo'}
					</Typography>
					<DpButton
						variant="text"
						sx={{ textDecoration: 'underline', fontSize: 'var(--font-size-sm)' }}
						onClick={isBlocked || isLoading ? undefined : onResendCode}
					>
						{isBlocked ? `Reenviar código (${remainingTime})` : 'Reenviar código'}
					</DpButton>
				</Stack>
			</Stack>
		</AdaptiveDialog>
	);
};
